import React from "react";
import { LANGS, LANG_NAME, inputCls, focusRing, useWP } from "./wpApi";

export function Field({ label, hint, children, required, className = "" }) {
  return (
    <label className={`block ${className}`}>
      <span className="block text-[11px] font-bold uppercase tracking-[0.16em] text-gray-400 mb-1.5">
        {label}{required && <span className="text-[#A3E635]"> *</span>}
      </span>
      {children}
      {hint && <span className="block mt-1 text-[11px] text-gray-500">{hint}</span>}
    </label>
  );
}

export function PagesInput({ value, onChange, testid = "wp-field-pages" }) {
  const { t } = useWP();
  const n = Math.min(100, Math.max(1, Number(value) || 1));
  return (
    <div className="flex items-center gap-3">
      <input type="number" min={1} max={100} step={1} inputMode="numeric" value={value} onChange={(e) => onChange(e.target.value)}
        className={`${inputCls} w-24`} aria-label={t("Seitenumfang")} data-testid={testid} />
      <input type="range" min={1} max={100} value={n} onChange={(e) => onChange(e.target.value)}
        className="flex-1 accent-[#A3E635]" aria-label={t("Seitenumfang")} data-testid={`${testid}-range`} />
    </div>
  );
}

export function LangToggle({ value, onChange, testid = "wp-lang" }) {
  const toggle = (l) => onChange(value.includes(l) ? value.filter((x) => x !== l) : [...value, l]);
  return (
    <div className="flex flex-wrap gap-2">
      {LANGS.map((l) => {
        const on = value.includes(l);
        return (
          <button type="button" key={l} onClick={() => toggle(l)} aria-pressed={on} aria-label={LANG_NAME[l]} title={LANG_NAME[l]} data-testid={`${testid}-${l}`}
            className={`px-4 py-2 rounded-lg text-sm font-bold border transition-colors ${focusRing} ${on ? "bg-[#A3E635] text-black border-[#A3E635]" : "border-white/10 text-gray-400 hover:text-white hover:bg-white/[0.05]"}`}>
            {l.toUpperCase()}
          </button>
        );
      })}
    </div>
  );
}

// Clientseitige Vorpruefung (deutscher Quelltext, Aufrufer uebersetzt); massgeblich bleibt die Serverpruefung.
export function checkCommon(f) {
  if (!/^\d+$/.test(String(f.page_scope)) || Number(f.page_scope) < 1 || Number(f.page_scope) > 100) return "Seitenumfang muss eine ganze Zahl von 1 bis 100 sein.";
  if (!f.languages.length) return "Bitte mindestens eine Sprache wählen (DE, FR, IT oder EN).";
  return null;
}
